import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HexagonIcon, XIcon } from 'lucide-react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsModal } from './TermsModal';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showCareersModal, setShowCareersModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  return <>
      <footer className="bg-navy border-t border-white/10 pt-16 pb-8" data-id="element-106" data-mp="39922nzchmct">
        <div className="max-w-7xl mx-auto px-6" data-id="element-107" data-mp="36d1st00yll7">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-108" data-mp="3ldaobi2207ky">
            {/* Brand Column */}
            <div className="md:col-span-1" data-id="element-109" data-mp="3qc3zh3tvbmhy">
              <div className="flex items-center gap-2 mb-4" data-id="element-110" data-mp="29z6tk9nn6feu">
                <img src="https://cdn.magicpatterns.com/uploads/4MwpWUASBxAuCwNdk51yeZ/fiqis3.png" alt="FIQIS Logo" className="w-7 h-7 object-contain" data-id="element-111" data-mp="29xlzsm95j0i1" />
                <span className="text-xl font-bold tracking-wider text-white" data-id="element-112" data-mp="3lbmuzun6vcgy">
                  FIQIS
                </span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-113" data-mp="3v7zx9gwsuynb">
                White-label financial infrastructure platform built for banks
                and credit unions to modernize securely.
              </p>
            </div>

            {/* Links Columns */}
            <div data-id="element-114" data-mp="33xcvurkbsqx">
              <h4 className="text-white font-semibold mb-4" data-id="element-115" data-mp="34gxjj8lkv8n">Platform</h4>
              <ul className="space-y-3 text-sm text-gray-400" data-id="element-116" data-mp="hstuojjf8k4q">
                <li data-id="element-117" data-mp="hsaeb79f63st">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-118" data-mp="huwlh5seehai">
                    Integration Layer
                  </a>
                </li>
                <li data-id="element-119" data-mp="qujkjkxnnb0e">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-120" data-mp="qtroya425da4">
                    Customer Intelligence
                  </a>
                </li>
                <li data-id="element-121" data-mp="tvw6yepkdbex">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-122" data-mp="twfnbqzkfrqu">
                    Micro-Lending
                  </a>
                </li>
                <li data-id="element-123" data-mp="13tajw4ca3i2h">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-124" data-mp="13t0uahv5bcxb">
                    Embedded P2P
                  </a>
                </li>
                <li data-id="element-125" data-mp="18m3sj3avbaju">
                  <Link to="/services/ai-native-engineering" className="hover:text-teal transition-colors" data-id="element-126" data-mp="1clm8rlrquxgc">
                    AI-Native Engineering
                  </Link>
                </li>
              </ul>
            </div>

            <div data-id="element-127" data-mp="1mhxmmg6zfvcw">
              <h4 className="text-white font-semibold mb-4" data-id="element-128" data-mp="1rilipga2j2dz">Company</h4>
              <ul className="space-y-3 text-sm text-gray-400" data-id="element-129" data-mp="1rgisav50778q">
                <li data-id="element-130" data-mp="3ocggmkhkx54o">
                  <Link to="/#about" className="hover:text-teal transition-colors" data-id="element-131" data-mp="3od83n6x41ujc">
                    About Us
                  </Link>
                </li>
                <li data-id="element-132" data-mp="2agyaywqwuhk0">
                  <button onClick={() => setShowCareersModal(true)} className="hover:text-teal transition-colors text-left" data-id="element-133" data-mp="25nvi6qtyjc4v">
                    Careers
                  </button>
                </li>
                <li data-id="element-134" data-mp="1wlm8g36ijmsj">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-135" data-mp="2tdzjgrjoazsp">
                    Newsroom
                  </a>
                </li>
                <li data-id="element-136" data-mp="2pdpglnr6gpi2">
                  <a href="mailto:arthur@fiqis.com" className="hover:text-teal transition-colors" data-id="element-137" data-mp="2pd5urvyepgyr">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-138" data-mp="18z5ziyaiafhu">
              <h4 className="text-white font-semibold mb-4" data-id="element-139" data-mp="18zpimibw79xg">Legal</h4>
              <ul className="space-y-3 text-sm text-gray-400" data-id="element-140" data-mp="13ys1m92mclxj">
                <li data-id="element-141" data-mp="141e805drwve6">
                  <button onClick={() => setShowPrivacyModal(true)} className="hover:text-teal transition-colors text-left" data-id="element-142" data-mp="2rv7p1x5q7y0s">
                    Privacy Policy
                  </button>
                </li>
                <li data-id="element-143" data-mp="2isyi1h9o2ms5">
                  <button onClick={() => setShowTermsModal(true)} className="hover:text-teal transition-colors text-left" data-id="element-144" data-mp="2ntw8eh4tyn4q">
                    Terms of Service
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-145" data-mp="31m2f7cm3fhri">
            <p className="text-sm text-gray-500" data-id="element-146" data-mp="36jkk8rwzpcu8">
              &copy; {currentYear} Financial Quantum Intelligence Systems. All
              rights reserved.
            </p>
            <div className="flex gap-4 text-sm text-gray-500" data-id="element-147" data-mp="1v604arcxlsxx">
              <span data-id="element-148" data-mp="1v3440wdm2s6b">arthur@fiqis.com</span>
              <span data-id="element-149" data-mp="1nl68jvs9lhm3"></span>
            </div>
          </div>
        </div>
      </footer>

      {/* Careers Modal */}
      {showCareersModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" onClick={() => setShowCareersModal(false)} data-id="element-150" data-mp="1ioz281vyi43m">
          <div className="bg-slate border border-white/10 rounded-2xl p-8 max-w-md mx-4 text-center shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-151" data-mp="1ro2mh96v0pjp">
            <div className="mb-6" data-id="element-152" data-mp="zxod9q9sk1ed">
              <div className="w-12 h-12 rounded-full bg-teal/10 border border-teal/20 flex items-center justify-center mx-auto mb-4" data-id="element-153" data-mp="zuacgmgs0091">
                <XIcon className="w-6 h-6 text-teal" data-id="element-154" data-mp="18wjkn5oknhj9" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-155" data-mp="18v8j7cilmlvb">
                No Open Positions
              </h3>
              <p className="text-gray-400" data-id="element-156" data-mp="g8nmrxn9njkw">
                Sorry, we are not currently hiring. Please check back later for
                future opportunities.
              </p>
            </div>
            <button onClick={() => setShowCareersModal(false)} className="bg-teal hover:bg-teal-400 text-navy font-semibold px-6 py-2.5 rounded-md transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,170,0.4)]" data-id="element-157" data-mp="2l9gpq5n7py5p">
              Close
            </button>
          </div>
        </div>}

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} data-id="element-158" data-mp="1xe46zz08t3e9" />

      {/* Terms of Service Modal */}
      <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} data-id="element-159" data-mp="278w7bal7m4cq" />
    </>;
}